<template>
	<div class="user-watches-patient-form">
		<form @submit.prevent="validateAndSubmit">
			<div class="form-group"><h2><span class="step">1</span>{{ $t('base.general.patient') }}</h2></div>
			<input-text v-model="model.name" name="patient_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<div class="form-group"><h2><span class="step">2</span>{{ $t('base.general.profile') }}</h2></div>
			<input-date v-model="model.birthday" name="patient_birthday" :placeholder="$t('labels.general.birthday')" rules="required"/>
			<input-text v-model="model.height" name="patient_height" :placeholder="$t('labels.general.height')" rules="integer"/>
			<input-text v-model="model.weight" name="patient_weight" :placeholder="$t('labels.general.weight')" rules="integer"/>
			<input-select v-model="model.gender" :options="genderTypes" name="patient_gender" :placeholder="$t('labels.general.gender')" rules="required"/>
			<input-select v-model="model.blood_type" :options="bloodTypes" name="patient_blood_type" :placeholder="$t('labels.general.blood_type')" rules="required"/>
			<div class="form-group"><h2><span class="step">3</span>{{ $t('base.general.group') }}</h2></div>
			<input-select v-model="model.group_id" :options="groupOptions" name="patient_group" :placeholder="$t('base.general.group')" rules="required"/>
			<div class="form-group"><button class="btn btn-small btn-round btn-primary" @click.prevent="onAddGroupClick">{{ $t('buttons.actions.add_group') }}</button></div>
			<div class="form-group"><h2><span class="step">4</span>{{ $t('base.general.device') }}</h2></div>
			<input-select-grouped v-model="model.device_id" :options="deviceOptions" name="patient_device" :placeholder="$t('base.general.device')" rules="required"/>
			<div class="form-group"><button class="btn btn-small btn-round btn-primary" @click.prevent="onAddDeviceClick">{{ $t('buttons.actions.add_device') }}</button></div>
			<error-box v-if="form_error" :error="form_error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
		<modal-box v-if="modalBox.open" @close="onModalBoxClose">
			<span slot="header">{{ modalBox.title }}</span>
			<form-group  v-if="isModalType(TYPE_GROUP)"   @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :group_id="modalBox.model_id" :type="TYPE_PATIENT"/>
			<form-device v-if="isModalType(TYPE_DEVICE)"  @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :device_id="modalBox.model_id"/>
		</modal-box>
	</div>
</template>

<script>
import FormTypes from './FormTypes'
import FormGroup from './UserWatchesFormGroup'
import FormDevice from './UserWatchesFormDevice'
import ApiCollection from '@/classes/api/ApiCollection'
import GroupCollection from '@/classes/GroupCollection'
import DeviceCollection from '@/classes/DeviceCollection'
export default {
	components: {
		FormGroup,
		FormDevice
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			TYPE_GROUP: FormTypes.GROUP,
			TYPE_PATIENT: FormTypes.PATIENT,
			TYPE_DEVICE: FormTypes.DEVICE,
			loading: false,
			form_error: null,
			model: {
				name: '',
				birthday: '',
				height: '',
				weight: '',
				gender: '',
				blood_type: '',
				group_id: '',
				device_id: ''
			},
			patientGroups: new ApiCollection(),
			deviceGroups: new ApiCollection(),
			devices: new ApiCollection(),
			groupOptions: [],
			deviceOptions: [],
			bloodTypes: [
				{ value: 'O-',  text: 'O-' },
				{ value: 'O+',  text: 'O+' },
				{ value: 'A-',  text: 'A-' },
				{ value: 'A+',  text: 'A+' },
				{ value: 'B-',  text: 'B-' },
				{ value: 'B+',  text: 'B+' },
				{ value: 'AB-', text: 'AB-' },
				{ value: 'AB+', text: 'AB+' }
			],
			genderTypes: [
				{ value: 'M', text: 'M' },
				{ value: 'F', text: 'F' }
			],
			modalBox: {
				open: false,
				action: '',
				model_id: '',
				type: '',
				title: ''
			}
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			this.loading = true
			this.$api.patients.add(this, this.user_uid, this.model)
				.then(response => {
					this.$log.info('patient form', 'patients.add OK', response)()
					this.$emit('done')
				}).catch(error => {
					this.$log.error('patient form', 'patients.add ERROR', error)()
					this.form_error = error
				}).finally(() => {
					this.loading = false
				})
		},
		getGroups () {
			this.patientGroups.loading = true
			this.patientGroups.data = []
			this.groupOptions = []
			this.$api.groups.patients.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('patient form', 'groups.patients.getAll OK', response)()
					this.patientGroups.data = new GroupCollection(response.body)
					this.groupOptions = this.patientGroups.toSelectOptions()
				}).catch(error => {
					this.$log.error('patient form', 'groups.patients.getAll ERROR', error)()
					this.patientGroups.error = error
				}).finally(() => {
					this.patientGroups.loading = false
				})
		},
		getDevices () {
			const funcGetGroups = () => {
				this.deviceGroups.loading = true
				this.deviceGroups.data = []
				return this.$api.groups.devices.getAll(this, this.user_uid)
					.then(response => {
						this.$log.info('patient form', 'groups.patients.getAll OK', response)()
						return response.body
					}).catch(error => {
						this.$log.error('patient form', 'groups.patients.getAll ERROR', error)()
						this.deviceGroups.error = error
					}).finally(() => {
						this.deviceGroups.loading = false
					})
			}
			const funcGetDevices = () => {
				this.devices.loading = true
				this.devices.data = []
				return this.$api.devices.getAll(this, this.user_uid)
					.then(response => {
						this.$log.info('patient form', 'devices.getAll OK', response)()
						return response.body
					}).catch(error => {
						this.$log.error('patient form', 'devices.getAll ERROR', error)()
						this.devices.error = error
					}).finally(() => {
						this.devices.loading = false
					})
			}
			Promise.all([funcGetGroups(), funcGetDevices()])
				.then(([groupsData, devicesData]) => {
					this.$log.info('groups + devices', 'getData() OK', groupsData, devicesData)()
					this.devices.data = new DeviceCollection(devicesData)
					this.deviceGroups.data = new GroupCollection(groupsData, this.devices.data)
					this.deviceOptions = this.deviceGroups.toSelectOptionsGrouped()
				}).catch(error => {
					this.$log.error('groups + devices', 'getData ERROR', error)()
				})
		},
		isModalType (type) {
			return this.modalBox.type === type
		},
		onAddGroupClick () {
			this.modalBox.action = 'add'
			this.modalBox.type = this.TYPE_GROUP
			this.modalBox.title = this.$t('buttons.actions.add_group')
			this.modalBox.open = open
		},
		onAddDeviceClick () {
			this.modalBox.action = 'add'
			this.modalBox.type = this.TYPE_DEVICE
			this.modalBox.title = this.$t('buttons.actions.add_device')
			this.modalBox.open = open
		},
		onModalBoxClose () {
			this.modalBox.action = ''
			this.modalBox.model_id = ''
			this.modalBox.type = ''
			this.modalBox.title = ''
			this.modalBox.open = false
		},
		onFormDone () {
			this.isModalType(this.TYPE_GROUP) ? this.getGroups() : this.getDevices()
			this.onModalBoxClose()
		}
	},
	created () {
		this.getGroups()
		this.getDevices()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesFormPatient.vue